import clsx from 'clsx'

import { MediaAnalysisTarget } from '@/common/model/media/mediaAnalysisTarget'

import FormLabel from '@/components/view/atoms/form/FormLabel'
import Text from '@/components/view/atoms/text/Text'
import InsideArea, { BgColor } from '@/components/view/layouts/area/InsideArea'
import FormRow from '@/components/view/layouts/form/FormRow'

// 「含む : ○○」のようなキー・値の1行
const KeyValueLine = ({ label, value }: { label: string; value: string | null }) => (
  <div className='flex items-center gap-3'>
    <div className='w-14'>
      <Text size={12} nowrap>
        {label}
      </Text>
    </div>
    <Text size={12}>:</Text>
    <Text size={12}>{value || '-'}</Text>
  </div>
)

interface Props {
  target: MediaAnalysisTarget
}

const AnalysisTargetSummary = ({ target }: Props) => {
  return (
    <InsideArea color={BgColor.TERTIARY} border>
      <div className='flex flex-col gap-2'>
        <FormRow align='center'>
          <FormLabel>サイトURL</FormLabel>
          <Text size={12}>{target.site_url}</Text>
        </FormRow>
        <FormRow>
          <FormLabel>キーワードフィルタ</FormLabel>
          <div className='flex flex-col gap-1.5'>
            <KeyValueLine label='含む' value={target.keyword_include} />
            <KeyValueLine label='含まない' value={target.keyword_exclude} />
          </div>
        </FormRow>
        <FormRow align={target.competitor_domains.length == 0 ? 'center' : 'start'}>
          <FormLabel>競合ドメイン</FormLabel>
          <div className={clsx('flex flex-col gap-1.5')}>
            {target.competitor_domains.length == 0 && <Text>-</Text>}
            {target.competitor_domains.map((domain, i) => (
              <KeyValueLine key={i} label={`競合${i + 1}`} value={domain} />
            ))}
          </div>
        </FormRow>
        {(target.own_brand || target.own_url || target.category) && (
          <FormRow>
            <FormLabel>自社ブランド</FormLabel>
            <div className='flex flex-col gap-1.5'>
              {target.own_brand && <KeyValueLine label='ブランド名' value={target.own_brand} />}
              {target.own_url && <KeyValueLine label='URL' value={target.own_url} />}
              {target.category && <KeyValueLine label='カテゴリ' value={target.category} />}
            </div>
          </FormRow>
        )}
        {target.competitor_brands.length > 0 && (
          <FormRow>
            <FormLabel>競合ブランド</FormLabel>
            <div className='flex flex-col gap-1.5'>
              {target.competitor_brands.map((brand, i) => (
                <KeyValueLine
                  key={i}
                  label={`競合${i + 1}`}
                  value={`${brand}${target.competitor_urls[i] ? `（${target.competitor_urls[i]}）` : ''}`}
                />
              ))}
            </div>
          </FormRow>
        )}
      </div>
    </InsideArea>
  )
}
export default AnalysisTargetSummary
